import {AxiosResponse} from 'axios'

import { api } from '@/helpers/core'

export interface Definition {
	name: string
	label: string
	type: string
	icon?: string
	color?: string
}

export default {
	getEntities (): Promise<AxiosResponse<Definition[]>> {
		return api.get('/settings/schema/')
	}
}
